const attribute = (Vue) => {
    Object.defineProperty(Vue.prototype, "get_DayTime", {
        get: function() {
            return function get_time() {
                let dateString = new Date().toLocaleDateString(); //获取当前日期
                dateString = dateString.replace(/\//g, "-");
                let start = new Date(dateString); //把当前日期变成时间戳
                let end = new Date(dateString + " 23:59:59");
                let timer_arr = [start,end];
                return timer_arr;
            }
        }
    });
    
    Object.defineProperty(Vue.prototype, "get_WookTime", {
        get: function() {
            return function get_time() {
                let date = new Date();
                let Sunday = new Date(date.getTime() - 1000*60*60*24*6);
                Sunday = new Date(Sunday.toLocaleDateString() + " 00:00:00");
                
                let dateString = new Date().toLocaleDateString(); //获取当前日期
                dateString = dateString.replace(/\//g, "-");
                let Monday = new Date(dateString + " 23:59:59");

                let timer_arr = [Sunday,Monday];
                return timer_arr;
                
            }
        }
    });
    Object.defineProperty(Vue.prototype, "my_IndexOf", {
        get: function() {
            return function myIndexOf(arr, id, sign) {
                let myIndex = -1;
                arr.map((item,index)=>{
                    if(item[sign] == id){
                        myIndex = index;
                    }
                });
                return myIndex;
            }
        }
    }) 

    Object.defineProperty(Vue.prototype, "appStore_params", {
        get: function() {
            return function set_Params(parasm) {
                for(let i in parasm) {
                    if(parasm[i] == '' || parasm[i] == undefined) {
                        delete parasm[i]
                    }
                };
                return parasm;
            }
        }
    })

    Object.defineProperty(Vue.prototype, "getWindonHref", {
		get: function() {
			return function() {
				var sHref = window.location.href;
				var args = sHref.split('?');
				if (args[0] === sHref) {
				    return '';
				}
				var hrefarr = args[1].split('#')[0].split('&');
				var obj = {};
				for (var i = 0; i < hrefarr.length; i++) {
				    hrefarr[i] = hrefarr[i].split('=');
				    obj[hrefarr[i][0]] = hrefarr[i][1];
				}
				return obj;
			}
		}
	});
}

export default attribute;


// WEBPACK FOOTER //
// ./src/utils/attribute.js